// app/(auth)/connexion/page.tsx
import AuthForm from "../../components/shared/auth/AuthForm";


export default function RegisterPage() {
  return <AuthForm type="register" />;
}